import { render, staticRenderFns } from "./MetalicosDialog.vue?vue&type=template&id=04cb250f&"
import script from "./MetalicosDialog.vue?vue&type=script&lang=js&"
export * from "./MetalicosDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports